import UsageLogService from 'src/modules/usageLog/usageLogService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'USAGELOG_VIEW';

const usageLogViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: usageLogViewActions.FIND_STARTED,
      });

      const record = await UsageLogService.find(id);

      dispatch({
        type: usageLogViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: usageLogViewActions.FIND_ERROR,
      });

      getHistory().push('/usage-log');
    }
  },
};

export default usageLogViewActions;
